
@switch (columnId) {
  @case ('type') {
    <lib-text-table-column>
      {{ element.type }}
    </lib-text-table-column>
  }
  @case ('value') {
    <div class="value-container">
      <div class="value-eye" (click)="onClickToggleShowSecret()">
        <i [class]="'far ' + (showSecret ? 'fa-eye-slash' : 'fa-eye')"></i>
      </div>
      <input
        class="value-input"
        [type]="showSecret ? 'text' : 'password'"
        [value]="element.value"
        [readonly]="true">
      @if (showSecret) {
        <lib-copy-to-clipboard-button [value]="element.value">
        </lib-copy-to-clipboard-button>
      }
    </div>
  }
  @case ('description') {
    <lib-text-table-column>
      {{ element.description }}
    </lib-text-table-column>
  }
  @case ('expirationDate') {
    <lib-date-time-label [dateUtc]="element.expirationUtc">
    </lib-date-time-label>
    <lib-table-column-sort [key]="sortingKeyForExpirationDate"></lib-table-column-sort>
  }
  @case ('delete') {
    <lib-vitu-tooltip text="Delete">
      <i class="far fa-trash global-table-cell-image-link" (click)="onClickDeleteSecret()"></i>
    </lib-vitu-tooltip>
  }
  @default {
  }
}
